(function () {
var $2dc82da4729600a7$var$minimalHeader = {
    init: function() {
        this.initScrollBehavior();
    },
    initScrollBehavior: function() {
        var el = document.querySelector('header.minimal-header');
        if (!el) return;
        var lastY = window.scrollY;
        var ticking = false;
        window.addEventListener('scroll', function() {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(function() {
                var currentY = window.scrollY;
                if (currentY > lastY && currentY > el.offsetHeight) el.classList.add('header--hidden');
                else el.classList.remove('header--hidden');
                lastY = currentY;
                ticking = false;
            });
        }, {
            passive: true
        });
    }
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function() {
    return $2dc82da4729600a7$var$minimalHeader.init();
});
else $2dc82da4729600a7$var$minimalHeader.init();

})();
//# sourceMappingURL=script.js.map
